<div class="header-container">
    <div class="select-container">
        <div class="icon-container">
            <span class="look-back-label">Look Back</span>
            <select [(ngModel)]="secondsBack">
                <option value="600">10 minutes</option>
                <option value="3600">1 hour</option>
                <option value="14400">4 hours</option>
                <option value="86400">24 hours</option>
                <option value="604800">1 week BE CAREFUL!</option>
                <option value="1209600">2 weeks BE CAREFUL!</option>
            </select>
        </div>
        <a href="javascript:void(0)" (click)="getLocaleTotals()" >Refresh Data</a>
        &nbsp;<span *ngIf="loading" class="shop-session-loading">Loading</span>
    </div>
</div>

<ssd-totals-table [countryTotals]="countryTotals" ></ssd-totals-table>


